import React, { useEffect, useState } from 'react'
import bgimage1 from '../../assets/images/bgimage1.jpg'
import UserNavbar from './UserNavbar'
import UserFooter from './UserFooter'
import { useDispatch, useSelector } from 'react-redux'
import { addReadlistTitle, addToReadlist, getReadlistTitle, subscriptionList } from '../../redux/authSlices'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2';


function UserSubscription() {
    const {subscriptionBooks} = useSelector((state)=>state.auth)
    const {readlistTitle} = useSelector((state)=>state.auth)
    const [showAddModal, setShowAddModal] = useState(false);
    const [selectedBookId, setSelectedBookId] = useState(null);
    const [newListTitle, setNewListTitle] = useState('');
    const [isCreating, setIsCreating] = useState(false);

    const dispatch = useDispatch()
    const navigate = useNavigate()
    console.log(subscriptionBooks)
    useEffect(()=>{
        dispatch(subscriptionList())
         dispatch(getReadlistTitle())
    },[dispatch])

    const handleGoButton = ()=>{
        navigate("/readlist")
    }
    const handleAddButton =async(bid)=>{
        setSelectedBookId(bid);
        setShowAddModal(true);
        // await dispatch(addToReadlist(bid));
        await dispatch(subscriptionList())
    }
    const handlieClick =(bid)=>{
        navigate(`/book/${bid}`)
      }
  return (
    <div
    style={{
      backgroundImage: `url(${bgimage1})`,
      backgroundAttachment: 'fixed',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
     
      overflow: 'hidden', // prevent body scroll
    }}
  >
    {/* Fixed Navbar */}
    <div style={{ position: 'fixed', top: 0, width: '100%', zIndex: 1000 }}>
    <UserNavbar/>
    </div>

    {/* Scrollable Content Below Navbar */}

   
    <div
      style={{
        marginTop: '50px', // adjust this based on your Navbar height
        height: 'calc(100vh - 50px)',
        overflowY: 'auto',
        backdropFilter: 'blur(4px)',
        backgroundColor: 'rgba(255, 255, 255, 0.2)', // optional for modern effect
        padding: '2rem',
        
      }}
    >

{/* <div style={{ minHeight: '200vh' }}> */}
<div className="container mt-2" style={{marginBottom:"50px"}}>
    <div className="profile-header mb-4">
        <h2 className="text-primary">Subscribed BOOKS</h2>

    </div>
            <div className="card p-4">
                <div className="row" style={{color:'black'}}>
                {subscriptionBooks && subscriptionBooks.length > 0 ?(
                     subscriptionBooks.map((book, index) => (
                        <div key={book.id || index} className="col-md-3 mb-4">
                        <div className="card h-100"  >
                            <div style={{cursor:"pointer",height:"90%"}} onClick={()=> handlieClick(book.id)}>
                            <img src={book.images ? `https://booksapp.in${book.images}` : '/default-book.jpg'} className="card-img-top" alt={book.title}/>
                            <div className="card-body">
                            <h5 className="card-title">{book.title.length > 25 ?(
                                book.title.substring(0,25) +'.......'
                            ):(
                                book.title
                            )}</h5>
                            <p className="card-text">{book.author}</p>
                            </div>
                            </div>
                            <div>
                                {book.isinreadlist?(
                                         <button style={{
                                            width: "100%",
                                            backgroundColor: "#4B0082", // soft green color
                                            color: "white",
                                            padding: "10px 0",
                                            marginTop: "15px",
                                            border: "none",
                                            borderRadius: "8px",
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                            transition: "background-color 0.3s ease"
                                        }}
                                        onMouseOver={(e) => (e.target.style.backgroundColor = "#800080")}
                                        onMouseOut={(e) => (e.target.style.backgroundColor = "#4B0082")}
                                             onClick={handleGoButton}
                                        >
                                        Go to Readlist</button>
                                ):(
                                    <button style={{
                                        width: "100%",
                                        backgroundColor: "#4CAF50", // soft green color
                                        color: "white",
                                        padding: "10px 0",
                                        marginTop: "15px",
                                        border: "none",
                                        borderRadius: "8px",
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                        transition: "background-color 0.3s ease"
                                    }}
                                    onMouseOver={(e) => (e.target.style.backgroundColor = "#45a049")}
                                    onMouseOut={(e) => (e.target.style.backgroundColor = "#4CAF50")}
                                         onClick={()=>{
                                            handleAddButton(book.id)}}
                                    >
                                    Add to Readlist</button>
                                )}
                           
                            </div>
                        </div>
                        </div>
                    ))
                ):(<p> You are not Subscribed any Books</p>) }
                        </div>
            </div>




            {showAddModal && (
                    <div className="modal-backdrop" style={{
                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1050
                    }}>
                        <div className="modal-content" style={{
                        width: '400px',
                        backgroundColor: '#fff',
                        padding: '20px',
                        borderRadius: '10px',
                        margin: '100px auto',
                        position: 'relative'
                        }}>
                      
                        <button
                            style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                            background: 'transparent',
                            border: 'none',
                            fontSize: '20px',
                            cursor: 'pointer'
                            }}
                            onClick={() => {
                            setShowAddModal(false);
                            setNewListTitle('');
                            }}
                        >❌</button>

                        <h5>Select a Reading List</h5>

                        {/* Show Input Box if no titles */}
                        {readlistTitle.length === 0 && (
                            <div className="d-flex mt-3">
                            <input
                                className="form-control"
                                type="text"
                                value={newListTitle}
                                onChange={(e) => setNewListTitle(e.target.value)}
                                placeholder="New list title"
                            />
                            <button
                                className="btn btn-success ms-2"
                                onClick={async () => {
                                if (!newListTitle.trim()) return;
                                setIsCreating(true);
                                const result = await dispatch(addReadlistTitle({ title: newListTitle }));
                                if (result.payload?.id) {
                                     await dispatch(getReadlistTitle());
                                     setNewListTitle('');
                                 }
                                setIsCreating(false);
                                }}
                                disabled={isCreating}
                            >+</button>
                            </div>
                        )}

                        {/* Render the readlist */}
                        <ul className="list-group mt-3">
                            {readlistTitle && readlistTitle.length > 0 ? (
                            readlistTitle.map((list) => (
                                <li key={list.id} className="list-group-item d-flex justify-content-between align-items-center">
                                {list.title}
                                <button
                                    className="btn btn-sm btn-success"
                                    onClick={async() => {
                                    const newItem = { bid: selectedBookId, titleId: list.id };
                                    const result = await dispatch(addToReadlist(newItem));
                                     if (result.payload && !result.payload.error) {
                                        Swal.fire({
                                          icon: 'success',
                                          title: 'Added!',
                                          text: 'Book added to your readlist successfully.',
                                          timer: 1500,
                                          showConfirmButton: false,
                                        });
                                      } else {
                                        Swal.fire({
                                          icon: 'info',
                                          title: 'Already Exists',
                                          text: result.payload?.message || 'Book is already in your readlist.',
                                        });
                                      }
                                     await dispatch(subscriptionList())
                                    setShowAddModal(false);
                                    }}
                                >
                                    +
                                </button>
                                </li>
                            ))
                            ) : null}
                        </ul>
                        </div>
                    </div>
                    )}


        </div>
      <UserFooter/>
    </div>
   
  </div>
  )
}

export default UserSubscription
